<div class="login-container">
  <div class="login-container-overlay"></div>
  <div class="row justify-content-md-center">
    <div class="col-lg-5 m-0 p-0">
      <div class="login-content">
        <ul class="nav nav-tabs" id="loginTab" role="tablist">
          <li class="nav-item left-tab text-center" role="presentation">
            <a class="nav-link" [class.active]="type == 'signup'" id="signup-tab" data-toggle="tab" href="#signup" role="tab"
               aria-controls="signup" aria-selected="true" [dir]="languageService.getDir()">
              {{'LOGIN_MODAL.SIGNUP.TAB' | translate}}
            </a>
          </li>
          <li class="nav-item right-tab text-center" role="presentation">
            <a class="nav-link" [class.active]="type == 'login'" id="login-tab" data-toggle="tab" href="#login" role="tab"
               aria-controls="login" aria-selected="false" [dir]="languageService.getDir()">
              {{'LOGIN_MODAL.LOGIN.TAB' | translate}}
            </a>
          </li>
        </ul>
        <div class="tab-content" id="loginTabContent">
          <div class="tab-pane fade" [class.show]="type == 'signup'" [class.active]="type == 'signup'"
               id="signup" role="tabpanel" aria-labelledby="signup-tab">
            <form *ngIf="!isSignUpSuccess" class="signup-form" [formGroup]="signUpForm" (ngSubmit)="onSignUpSubmit()">
            <div class="input-group">
              <input type="email" name="registerEmail" class="form-control" formControlName="registerEmail"
                     [class.text-right]="languageService.isCurrent('Hebrew')"
                     id="registerEmail" placeholder="{{'LOGIN_MODAL.SIGNUP.EMAIL' | translate}}"
                     [dir]="languageService.getDir()">
              <div class="input-group-append">
                <div class="input-group-text"><span><i class="fa-solid fa-at"></i></span></div>
              </div>
<!--              <div class="alert-danger" *ngIf="sf.submitted && email.invalid">-->
<!--                <div *ngIf="email.errors.required">Email is required</div>-->
<!--                <div *ngIf="email.errors.email">Email must be a valid email address</div>-->
<!--              </div>-->
            </div>
            <div class="input-group justify-content-end">
              <ngx-intl-tel-input
                [cssClass]="'form-control text-right'"
                [preferredCountries]="[CountryISO.Israel]"
                [enableAutoCountrySelect]="false"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [separateDialCode]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.Israel"
                [numberFormat]="PhoneNumberFormat.International"
                [phoneValidation]="true"
                [inputId]="'phone'"
                name="phone"
                formControlName="phone"></ngx-intl-tel-input>
              <div class="input-group-append">
                <div class="input-group-text"><span><i class="fas fa-phone"></i></span></div>
              </div>
            </div>
<!--              <div class="input-group">-->
<!--                <input type="text" class="form-control text-right"-->
<!--                       id="inputSignupPhone" placeholder="{{'LOGIN_MODAL.SIGNUP.PHONE' | translate}}"-->
<!--                       [(ngModel)]="signUpForm.phone" required phone #phone="ngModel" [dir]="languageService.getDir()">-->
<!--                <div class="alert-danger" *ngIf="sf.submitted && phone.invalid">-->
<!--                  <div *ngIf="phone.errors.required">Phone number is required</div>-->
<!--                  <div *ngIf="phone.errors.phone">Must be a valid phone number</div>-->
<!--                </div>-->
<!--                <div class="input-group-append">-->
<!--                  <div class="input-group-text"><span><i class="fas fa-phone"></i></span></div>-->
<!--                </div>-->
<!--              </div>-->
              <div class="form-row">
                <div class="input-group input-name">
                  <input type="text" name="firstname" class="form-control" id="firstname" formControlName="firstname"
                         [class.text-right]="languageService.isCurrent('Hebrew')"
                         placeholder="{{'LOGIN_MODAL.SIGNUP.FIRSTNAME' | translate}}" [dir]="languageService.getDir()">
                  <div class="input-group-append">
                    <div class="input-group-text"><span><i class="fas fa-user"></i></span></div>
                  </div>
<!--                  <div class="alert-danger" *ngIf="sf.submitted && firstname.invalid">-->
<!--                    <div *ngIf="firstname.errors.required">First name is required</div>-->
<!--                    <div *ngIf="firstname.errors.minlength">First name must be at least 2 characters</div>-->
<!--                    <div *ngIf="firstname.errors.maxlength">First name must be at most 20 characters</div>-->
<!--                  </div>-->
                </div>
                <div class="input-group input-name">
                  <input type="text" name="lastname" class="form-control" id="lastname" formControlName="lastname"
                         [class.text-right]="languageService.isCurrent('Hebrew')"
                         placeholder="{{'LOGIN_MODAL.SIGNUP.LASTNAME' | translate}}" [dir]="languageService.getDir()">
                  <div class="input-group-append">
                    <div class="input-group-text"><span><i class="fas fa-user"></i></span></div>
                  </div>
<!--                  <div class="alert-danger" *ngIf="sf.submitted && lastname.invalid">-->
<!--                    <div *ngIf="lastname.errors.required">Last name is required</div>-->
<!--                    <div *ngIf="lastname.errors.minlength">Last name must be at least 2 characters</div>-->
<!--                    <div *ngIf="lastname.errors.maxlength">Last name must be at most 20 characters</div>-->
<!--                  </div>-->
                </div>
              </div>
              <div class="input-group">
                <input type="password" class="form-control" id="registerPassword" formControlName="registerPassword"
                       [class.text-right]="languageService.isCurrent('Hebrew')"
                       placeholder="{{'LOGIN_MODAL.SIGNUP.PASSWORD' | translate}}" [dir]="languageService.getDir()">
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fas fa-key"></i></span></div>
                </div>
<!--                <div class="alert-danger" *ngIf="sf.submitted && password.invalid">-->
<!--                  <div *ngIf="password.errors.required">Password is required</div>-->
<!--                  <div *ngIf="password.errors.minlength">Password must be at least 6 characters</div>-->
<!--                </div>-->
              </div>
              <div class="input-group">
                <input type="password" class="form-control" id="passwordConfirm" formControlName="passwordConfirm"
                       [class.text-right]="languageService.isCurrent('Hebrew')"
                       placeholder="{{'LOGIN_MODAL.SIGNUP.PASSWORD_CONFIRM' | translate}}" [dir]="languageService.getDir()">
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fas fa-key"></i></span></div>
                </div>
<!--                <div class="alert-danger" *ngIf="sf.submitted && passwordConfirm.invalid">-->
<!--                  <div *ngIf="passwordConfirm.errors.required">Confirm Password is required</div>-->
<!--                  <div *ngIf="passwordConfirm.errors.minlength">Confirm Password must be at least 6 characters</div>-->
<!--                </div>-->
              </div>
              <div class="input-group" >
                <div class="checkbox-container text-center">
                  <label>
                    <input type="checkbox" class="text-right" id="confirmed" formControlName="confirmed">
                    I confirm
                  </label>
                  <div class="download-links">
                    <a href="/assets/files/Terms of Service for Quick Hub - 20-05-2024.pdf" download="File1.pdf">Terms of use </a>
                    <a href="/assets/files/Quick Hub Privacy Policy.pdf" download="File2.pdf">Privacy policy </a>
                    <a href="/assets/files/Terms of use Quick Hub Website - 20-05-2024.pdf" download="File2.pdf">Terms of use Website</a>
                  </div>
                </div>
              </div>
              <div class="form-buttons">
                <div class="submit-button-container text-center">
                  <button type="submit" class="primary-button submit-button"
                          [dir]="languageService.getDir()"
                          [disabled]="!signUpForm.controls.confirmed.value">
                    {{'LOGIN_MODAL.SIGNUP.SUBMIT' | translate}}
                  </button>
                </div>
              </div>
              <div class="alert alert-warning" *ngIf="isSignUpFailed">
                Signup failed. <br />{{ errorMessage }}
              </div>
            </form>
          </div>
          <div class="tab-pane fade" [class.show]="type == 'login'" [class.active]="type == 'login'"
               id="login" role="tabpanel" aria-labelledby="login-tab">
            <form *ngIf="!isLoggedIn" class="login-form" [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
              <div class="input-group">
                <input type="email" class="form-control" id="loginEmail" formControlName="loginEmail"
                       [class.text-right]="languageService.isCurrent('Hebrew')"
                       placeholder="{{'LOGIN_MODAL.LOGIN.EMAIL' | translate}}" [dir]="languageService.getDir()">
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fa-solid fa-at"></i></span></div>
                </div>
<!--                <div class="alert alert-danger" role="alert" *ngIf="lf.submitted && username.invalid">-->
<!--                  Username is required!-->
<!--                </div>-->
              </div>
              <div class="input-group">
                <input type="password" class="form-control" id="loginPassword" formControlName="loginPassword"
                       [class.text-right]="languageService.isCurrent('Hebrew')"
                       placeholder="{{'LOGIN_MODAL.LOGIN.PASSWORD' | translate}}"
                       [dir]="languageService.getDir()">
                <div class="input-group-append">
                  <div class="input-group-text"><span><i class="fas fa-key"></i></span></div>
                </div>
<!--                <div class="alert alert-danger" role="alert" *ngIf="lf.submitted && password.invalid">-->
<!--                  <div *ngIf="password.errors.required">Password is required</div>-->
<!--                  <div *ngIf="password.errors.minlength">Password must be at least 6 characters</div>-->
<!--                </div>-->
              </div>
              <div class="form-row">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="rememberMe">
                  <label class="form-check-label" for="rememberMe" [dir]="languageService.getDir()">
                    {{'LOGIN_MODAL.LOGIN.REMEMBER_ME' | translate}}
                  </label>
                </div>
                <div class="forgot-link text-right" [dir]="languageService.getDir()">
                  <a [routerLink]="['/password/reset_token']">{{'LOGIN_MODAL.LOGIN.FORGOT_PASSWORD' | translate}}</a>
                </div>
              </div>
              <div class="form-buttons">
                <div class="submit-button-container text-center">
                  <button type="submit" class="primary-button submit-button" [dir]="languageService.getDir()">
                    {{'LOGIN_MODAL.LOGIN.SUBMIT' | translate}}
                  </button>
                </div>
                <div class="form-group">
                  <div class="alert alert-danger" role="alert" *ngIf="isLoginFailed">Login failed. {{ errorMessage }}</div>
                </div>
                <!--                <button type="button" class="btn btn-danger social-login-button"-->
                <!--                        (click)="googleLogin()" [dir]="languageService.getDir()">-->
                <!--                  {{'LOGIN_MODAL.LOGIN.SIGN_IN_GOOGLE' | translate}}-->
                <!--                </button>-->
                <!--                <button type="button" class="btn btn-primary social-login-button"-->
                <!--                        (click)="facebookLogin()" [dir]="languageService.getDir()">-->
                <!--                  {{'LOGIN_MODAL.LOGIN.SIGN_IN_FACEBOOK' | translate}}-->
                <!--                </button>-->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
